
import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { RaffleTicketOVO } from './vo/raffle.vo' 


@Component
export default class MyTickets extends Vue {
  // 1 = 보유 응모권 , 0 = 사용한 응모권
  ticketDiv = 1;
  ticketHistory = [] as Array<RaffleTicketOVO>;

  get ticketChanged() {
    return this.ticketHistory.filter(ticket=>{
      return ticket.availableTicket == this.ticketDiv;
    });    
  }

  created(): void {
    axios.get('/mypage/tickets')
    .then(r=>{
        this.ticketHistory = r.data;
    })
  }
}
